import { Injectable } from "@angular/core";
import { ImprintLinkExtension } from "@geolib/geoappbase-client";
import { AppConstants } from "../common/app-constants";

@Injectable({ providedIn: "root" })
export default class GeobusImpressumLinkExtension extends ImprintLinkExtension {

    public get linkUrl(): string {
        return AppConstants.PATH_OF_IMPRESSUM;
    }
}
